import Layout from '../../components/layout/Layout';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';

function blogPostTemplate({ pageContext }) {
  const post = pageContext;

  // const { title, author, date } = post.frontmatter;

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{post.title} | Kratos Ohio Blog</title>

        <meta name="description" content={post.description} />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link rel="canonical" href="https://ohio.kratosgp.com/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="blog post" />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.description} />
        <meta property="og:url" content="https://ohio.kratosgp.com/" />
        <meta property="og:site_name" content="Kratos Gas &amp; Power Ohio" />
        {post.category &&
          post.category.map(tag => {
            return <meta property="article:tag" content={tag.title}></meta>;
          })}
        <meta name="twitter:card" content={post.image} />
        <meta name="twitter:description" content={post.description} />
        <meta name="twitter:title" content={post.title} />
        <meta name="facebook-domain-verification" content="5b41f4enw35ff9sf4zkk2uhqyr2axk" />
        <link
          rel="icon"
          type="image/png"
          href="https://imgix.cosmicjs.com/672f0a90-c69e-11ea-8fc2-8d973b3e3b71-kratosfavicon.png"
        />
      </Helmet>
      <main class="mt-10 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28">
        <div class="mb-8 text-center ">
          <h2 class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
            {post.title}
          </h2>
        </div>
        <div class="mb-8 ">
          <div class="mb-8 flex justify-center">
            <h2 class="text-base tracking-loose leading-10 text-gray-400 ">{post.date}</h2>
            <h2 class="ml-10 text-base tracking-loose leading-10 text-yellow ">
              {' '}
              {post.category &&
                post.category.map(tag => {
                  return <p className="-mt-10 leading-3 inline-block pr-2 ">{tag.title + ','}</p>;
                })}
            </h2>
          </div>
          <div class="border-b border-gray-400"></div>

          <div class="mx-auto text-base text-gray-500 sm:text-lg md:mt-10 md:mb-10 md:text-xl ">
            <img class="mx-auto h-auto w-auto rounded-lg" src={post.image} alt=""></img>
          </div>
          <p class="pl-6 mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl ">
            <div className="pb-6" dangerouslySetInnerHTML={{ __html: post.content }} />
          </p>
        </div>

        <div className="text-center pt-10 pb-10 border-t md:inline lg:block ">
          {post.previous ? (
            <Link to={'blog/' + post.previous.slug}>
              <button className="mb-6 lg:mb-0 mr-10  text-primary tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:text-blue-500 transition ease-in-out duration-500 focus:outline-none ">
                <svg
                  className="w-4 mr-4"
                  transform="scale(-1, 1)"
                  fill="darkred"
                  viewBox="0 0 24 24"
                >
                  <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                </svg>
                Prev. Post
              </button>
            </Link>
          ) : (
            <div className="mr-32  text-primary tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:text-blue-500 transition ease-in-out duration-500 "></div>
          )}

          <Link to="/blog/">
            <button className="bg-blue-600  rounded-full text-blue tracking-wider inline-flex items-center py-4 border border-transparent text-sm leading-4 hover:bg-blue-500 transition ease-in-out duration-500 focus:outline-none">
              Back to Blog Home
            </button>
          </Link>

          {post.next ? (
            <Link to={'blog/' + post.next.slug}>
              <button className="mt-6 lg:mt-0 ml-10  text-primary tracking-wider inline-flex items-center px-16 py-4 text-sm leading-4 hover:text-blue-500 transition ease-in-out duration-500 focus:outline-none ">
                Next Post
                <svg className="w-4 ml-4" fill="darkred" viewBox="0 0 24 24">
                  <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                </svg>
              </button>
            </Link>
          ) : (
            <div className=" ml-32 text-primary tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:text-blue-500 transition ease-in-out duration-500 "></div>
          )}
        </div>

        <div class=" border-b border-gray-400"></div>
      </main>
    </Layout>
  );
}
export default blogPostTemplate;

/*  <div className="text-center pt-10 pb-10 border-t md:inline lg:block ">
              {post.previous ? (
                <Link to={'blog/posts/' + post.previous.slug}>
                  <button className="mb-6 lg:mb-0 mr-10  text-primary tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:text-blue-500 transition ease-in-out duration-500 ">
                    <svg
                      className="w-4 mr-4"
                      transform="scale(-1, 1)"
                      fill="#0f3f9d"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                    </svg>
                    Prev. Post
                  </button>
                </Link>
              ) : (
                <div className="mr-32  text-primary tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:text-blue-500 transition ease-in-out duration-500 "></div>
              )}

              <Link to="/blog/">
                <button className="bg-blue-600  rounded-full text-white tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:bg-blue-500 transition ease-in-out duration-500 ">
                  Back to Blog Home
                </button>
              </Link>

              {post.next ? (
                <Link to={'blog/posts/' + post.next.slug}>
                  <button className="mt-6 lg:mt-0 ml-10  text-primary tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:text-blue-500 transition ease-in-out duration-500 ">
                    Next Post
                    <svg className="w-4 ml-4" fill="#0f3f9d" viewBox="0 0 24 24">
                      <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                    </svg>
                  </button>
                </Link>
              ) : (
                <div className=" ml-32 text-primary tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:text-blue-500 transition ease-in-out duration-500 "></div>
              )}
            </div>*/
